import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import useLenis from "@/hooks/useLenis";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import BrandStory from "@/components/site/BrandStory";
import Services from "@/components/site/Services";
import Difference from "@/components/site/Difference";
import Process from "@/components/site/Process";
import Why from "@/components/site/Why";
import AreasMarquee from "@/components/site/AreasMarquee";
import Testimonials from "@/components/site/Testimonials";
import QuoteForm from "@/components/site/QuoteForm";
import FinalCTA from "@/components/site/FinalCTA";

const Home = () => {
  useLenis();
  return (
    <div className="grain relative bg-warm-white">
      <Nav />
      <main>
        <Hero />
        <BrandStory />
        <Services />
        <Difference />
        <Process />
        <Why />
        <AreasMarquee />
        <Testimonials />
        <QuoteForm />
        <FinalCTA />
      </main>
    </div>
  );
};

function App() {
  useEffect(() => {
    document.title = "Casa Galênê Cleaning — Where Luxury Meets Serenity";
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
